import React, { Component } from 'react';
import PropTypes from 'prop-types';

import HomepageComponent from '../HomepageComponent/HomepageComponent';

import './styles/ContentThumbnail.scss';

class ContentThumbnail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageRatio: 0,
      videoRatio: 0
    };

    this.videoRef = React.createRef();
    this.videoRef0 = React.createRef();
    this.videoRef1 = React.createRef();
    this.videoRef2 = React.createRef();

    this.onActivated = this.onActivated.bind(this);
    this.onDeactivated = this.onDeactivated.bind(this);
  }

  componentDidMount() {
    if (this.props.image) {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        this.setState({
          imageRatio: (img.height / img.width) * 100
        })
      };

      img.src = this.props.image;
    }

    if (this.props.video) {
      this.videoRef.current.addEventListener('loadedmetadata', (e) => {
        console.log(e.target.videoHeight / e.target.videoWidth)
        this.setState({
          videoRatio: (e.target.videoHeight / e.target.videoWidth) * 100
        })
      });
    }
  }

  onActivated() {
    if (this.props.mediaType === 'video' && this.videoRef.current) {
      this.videoRef.current.play();
    }

    if (this.props.mediaType === 'fan') {
      console.log('play')
      const videosExist = this.videoRef.current && this.videoRef1.current && this.videoRef2.current;
      
      if (videosExist) {
        this.videoRef.current.play();
        this.videoRef1.current.play();
        this.videoRef2.current.play();
      }
    }
  }

  onDeactivated() {
    if (this.props.mediaType === 'video' && this.videoRef.current) {
      this.videoRef.current.currentTime = 0;
      this.videoRef.current.pause();
    }

    if (this.props.mediaType === 'fan') {
      const videosExist = this.videoRef.current && this.videoRef1.current && this.videoRef2.current;
      
      if (videosExist) {
        this.videoRef.current.currentTime = 0;
        this.videoRef1.current.currentTime = 0;
        this.videoRef2.current.currentTime = 0;

        this.videoRef.current.pause();
        this.videoRef1.current.pause();
        this.videoRef2.current.pause();
      }
    }
  }

  renderMediaElement() {
    const { mediaType, image, video } = this.props;
    const { imageRatio, videoRatio } = this.state;
    const imageStyle = { backgroundImage: `url(${image})`, paddingBottom: `${imageRatio * 1.5}%` };
    const videoStyle = { paddingBottom: `${videoRatio}%` };

    if (mediaType === 'video') {
      return <video src={video} ref={this.videoRef} loop muted playsInline />
    } else if (mediaType === 'scrolling' && image) {
      return <figure className="ContentThumbnail-image ContentThumbnail-image--scrolling" style={imageStyle} />
    } else if (mediaType === 'fan') {
      return (
        <div className="ContentThumbnail-fan" style={videoStyle}>
          <video src={video} ref={this.videoRef} muted playsInline />
          <video src={video} ref={this.videoRef1} muted playsInline />
          <video src={video} ref={this.videoRef2} muted playsInline />
        </div>
      )
    } else if (image) {
      return <img className="ContentThumbnail-image" src={image} alt="" />
    }

    return null;
  }

  render() {
    const { category, title, cta, href } = this.props;

    return (
      <HomepageComponent
        className="ContentThumbnail"
        hoverClass="ContentThumbnail--hover"
        href={href}
        onActivated={this.onActivated}
        onDeactivated={this.onDeactivated}
        target="_blank"
      >
        <div className="ContentThumbnail-content">
          
          { this.renderMediaElement() }

          <h3>{ category } </h3>
          <h2>{ title }</h2>
          
          <div className="Cta">
            <span>{ cta }</span>
          </div>
        </div>
      </HomepageComponent>
    );
  }
}

ContentThumbnail.propTypes = {
  title: PropTypes.string,
  category: PropTypes.string,
  href: PropTypes.string,
  image: PropTypes.string,
  mediaType: PropTypes.string,
  cta: PropTypes.string
};

ContentThumbnail.defaultProps = {
  cta: 'Watch'
};

export default ContentThumbnail;